




































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { ImageService } from '../services/image';
import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

export type ImageSelectOptions = {
  title: string;
  imageSize?: string;
};

@Component
export default class ImageSelectComponent extends Vue {
  @Prop({ default: false })
  private clearAfterEdit: boolean;

  @Prop()
  src: string;

  @Prop({
    default: () => ({
      title: 'Selecionar a Imagem',
      imageSize: '1024x1038',
    }),
  })
  options: ImageSelectOptions;

  private image: HTMLImageElement = null;

  dataURLtoFile(dataurl: string, filename: string) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  async created() {
    if (this.src) {
      this.image = await ImageService.readImage(
        this.dataURLtoFile(
          this.src.includes('http') || this.src.includes('https') ? await this.getBase64Image(this.src) : this.src,
          `${Date.now()}`,
        ),
      );
    }
  }

  public async getBase64Image(imgUrl: string): Promise<string> {
    const img = new Image();
    return new Promise<string>((resolve) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, '');
        resolve(dataURL); // the base64 string
      };
      // set attributes and src
      img.setAttribute('crossOrigin', 'anonymous'); //
      img.src = imgUrl;
    });
  }

  async onLoadImage($event: any) {
    const files: FileList = $event.target?.files;
    const file: File = files[0];
    if (!file) {
      return;
    }
    this.image = await ImageService.readImage(file);
    if (this.is_image_size_wrong) {
      toast(
        `A imagem pode ficar distorcida por não estar no tamanho correto: ${
          this.options.imageSize || '1024x1038'
        }. Tamanho da Imagem: ${this.image.width}x${this.image.height}`,
        ToastType.WARNING,
        {
          timeout: 9000,
        },
      );
    }
    this.onEditImage(this.image);
    if (this.clearAfterEdit) {
      this.image = null;
    }
  }

  @Emit()
  onEditImage(image: HTMLImageElement) {
    return { imageBase64: image.src };
  }

  get default_image() {
    return require('../assets/img/default_event_image.jpg');
  }

  get is_image_size_wrong(): boolean {
    return (
      this.image &&
      (this.image.width !== Number((this.options.imageSize || '1024x1038').split('x')[0]) ||
        this.image.height !== Number((this.options.imageSize || '1024x1038').split('x')[1]))
    );
  }
}
